export default {
	COLUNA: "COLUNA",
	COLUNA_SIMPLES: "COLUNA_SIMPLES",
	PIZZA: "PIZZA",
	BARRA: "BARRA",
	DISPERSAO: "DISPERSAO",
	LINHA: "LINHA"
}
